import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';
import { Table } from 'antd';
import { actividadApi } from '../utils/api';
import CustomCellRender from './base/CustomCellRender';
// eslint-disable-next-line
const axios = require('axios');

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
`;

const Container2 = styled.div`
  position: absolute;
  width: 100%;
  overflow: auto;
  height: 100%;
  left: 0;
`;

const ActividadesAsociadasPopup = ({
  parentId,
  onCancel,
  onOk,
  itemSelected,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [data, setData] = useState([]);

  useEffect(() => {
    if (parentId) {
      actividadApi
        .get(`/indexByParent/${parentId}`)
        .then((response) => {
          if (itemSelected && itemSelected.length > 0) {
            const result = response.data.map((value) => {
              if (
                itemSelected.some(
                  (item) => value.id === item.actividad_id && !item.deleted
                )
              ) {
                return false;
              } else {
                return {
                  ...value,
                  actividad_id: value.id,
                  id: null,
                  deleted: false,
                  propietarios: value.propietarios.map((item) => {
                    return {
                      ...item,
                      key: item.propietario_id,
                      id: null,
                      deleted: false,
                    };
                  }),
                };
              }
            });

            setData(result.filter((item) => item));
          } else {
            setData(
              response.data.map((value) => {
                return {
                  ...value,
                  actividad_id: value.id,
                  id: null,
                  deleted: false,
                  propietarios: value.propietarios.map((item) => {
                    return {
                      ...item,
                      key: item.propietario_id,
                      id: null,
                      deleted: false,
                    };
                  }),
                };
              })
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // eslint-disable-next-line
  }, [parentId]);

  const onSelectChange = (selectedRowKeys) => {
    const result = data.filter((item) =>
      selectedRowKeys.some((value) => value === item.actividad_id)
    );

    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(result);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  data.forEach((value) => {
    value['key'] = value.actividad_id;
  });

  const columns = [
    {
      ellipsis: true,
      title: 'Establecimiento',
      dataIndex: 'establecimiento_nombre',
    },
    {
      ellipsis: true,
      title: 'Cultivo',
      dataIndex: 'cultivo_nombre',
    },
    {
      ellipsis: true,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
  ];

  return (
    <DraggableModalProvider>
      <DraggableModal
        visible={true}
        okText="Guardar"
        cancelText="Salir"
        onCancel={(e) => onCancel()}
        onOk={(e) => onOk(selectedRows)}
        title="Actividades"
        initialWidth={450}
        initialHeight={450}
      >
        <Container>
          <Container2>
            <Table
              tableLayout="auto"
              size="small"
              columns={columns}
              dataSource={data}
              pagination={false}
              rowSelection={rowSelection}
            />
          </Container2>
        </Container>
      </DraggableModal>
    </DraggableModalProvider>
  );
};

export default ActividadesAsociadasPopup;
